module.exports = __webpack_public_path__ + "img/91.19b7572c.jpg";